// extracted by mini-css-extract-plugin
module.exports = {"row":"FreeUsageNotice_row__LkG3e","glyph":"FreeUsageNotice_glyph__o2eCT"};